import React, { Fragment, memo } from 'react';
//Views
import OfflineDevice from '../../../offlineDevice';
import Chart from '../../../chart';
import RecentAlerts from '../../../recentAlerts';
import LandmarkVisit from '../../../landmarkVisit';
import LandmarkRealTime from '../../../landmarkRealTime';
import EmissionCheck from '../../../EmissionCheck';

const Gadgets = ({ item, update,changesFilters, setChangesFilters }) => {
  
  const renderComponent = (item) => {

        switch (item.type) {
            case 'OfflineDevices':
                return (
                    <OfflineDevice item={item} update={update} />
                );
            case 'Chart':
                return (
                    <Chart key={item.id} item={item} update={update} />
                );
            case 'RecentAlerts':
                return (
                    <RecentAlerts key={item.id} item={item} update={update} />
                );
           case 'LandmarkVisit':
                return (
                    <LandmarkVisit key={item.id} item={item} update={update} changesFilters={changesFilters} setChangesFilters={setChangesFilters} />
                );
            case 'LandmarkRealTime':
                return (
                    <LandmarkRealTime key={item.id} item={item} update={update} changesFilters={changesFilters} setChangesFilters={setChangesFilters} />
                );
            case 'EmissionCheck':
                return (
                    <EmissionCheck key={item.id} item={item} update={update} changesFilters={changesFilters} setChangesFilters={setChangesFilters} />
                );
        }
    };

    return (
        <Fragment>
            {(
                renderComponent(item)
            )}
        </Fragment>
    );

}

export default memo(Gadgets);
